var map = {
	"./1_ava.jpg": "f032",
	"./2_ava.jpg": "da15",
	"./3_ava.jpg": "d01c",
	"./4_ava.jpg": "fffa",
	"./5_ava.jpg": "b27b",
	"./6_ava.jpg": "70d4",
	"./7_ava.jpg": "193e",
	"./8_ava.jpg": "f2d6",
	"./9_ava.jpg": "52a5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9582";